import React, { Component } from "react";
import LazyLoad from "react-lazy-load";

import { GlobalContext } from "../../app/providers/GlobalState";

import ConteudoResumo from "./ConteudoResumo";
import Controlos from "../_Aux/Controlos";

class Resumo extends Component {
    static contextType = GlobalContext;

    render() {
        return (
            <div className="questionario-resumo">
                <div className="player-wrapper">
                    <ConteudoResumo />
                    <Controlos
                        backUrl={localStorage.getItem("player_back_url")}
                        sameUrl={true}
                        temRating
                        temAnotacoes
                        temMarcador
                        temMensagens
                        conclusao
                    />
                </div>
            </div>
        );
    }
}

export default Resumo;
